import React, { Dispatch } from 'react';

import Location from '@r6digital/rapidstor-types/react/entities/Location';
import UnitType from '@r6digital/rapidstor-types/react/entities/UnitType';
import Deal from '@r6digital/rapidstor-types/types/Deal';
import { DescriptorJblOptionText } from '@r6digital/rapidstor-types/types/Descriptor';

import { UpgradeDescriptor } from '@/features/rapidstor/UnitOptions';

import BaseOption from './base';
import MapOption from './map';

type Theme = 'base' | 'map';

interface Props {
    option: UnitType;
    dealObject?: Deal;
    initialRate?: number;
    desktopOption?: boolean;
    location: Location;
    selected: boolean;
    default?: boolean;
    showTotalPrice?: boolean;
    wizard?: boolean;
    optionText?: DescriptorJblOptionText;
    descriptor?: UpgradeDescriptor;
    theme: Theme;

    setSelectedID: Dispatch<React.SetStateAction<string>>;
    setDefaultUnitType?: () => void;
    onOptionSelect?: (option: UnitType, descriptor?: UpgradeDescriptor) => void;
}

export default function Option({
    option,
    dealObject,
    initialRate,
    desktopOption,
    location,
    selected,
    default: defaultOption,
    showTotalPrice,
    wizard,
    setSelectedID,
    setDefaultUnitType,
    descriptor,
    optionText,
    theme,
    onOptionSelect,
}: Props) {
    if (theme === 'base') {
        return (
            <BaseOption
                option={option}
                dealObject={dealObject}
                location={location}
                selected={selected}
                setSelectedID={setSelectedID}
                desktopOption={desktopOption}
                initialRate={initialRate}
                default={defaultOption}
                showTotalPrice={showTotalPrice}
                descriptor={descriptor}
                wizard={wizard}
                optionText={optionText}
                onOptionSelect={onOptionSelect}
            />
        );
    }
    return (
        <MapOption
            option={option}
            location={location}
            selected={selected}
            setSelectedID={setSelectedID}
            setDefaultUnitType={setDefaultUnitType}
            showTotalPrice={showTotalPrice}
            default={defaultOption}
            initialRate={initialRate}
        />
    );
}
